// ================= IMPORTS =================

import React, { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Avatar,
  CircularProgress,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

import axios from "api/baseurl";

// ================= COMPONENT =================

function MessageCareCoordinatorPopup({
  open,
  handleClose,
  patientId,
  
}) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const token = JSON.parse(localStorage.getItem("loginData"))?.token;
const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
    const role = loginData?.role;
  // ================= SEND MESSAGE API =================

  const handleSendMessage = async () => {
    if (!message.trim()) {
      alert("Please enter message");
      return;
    }

    try {
      setLoading(true);

      const body = {
        patientId: patientId,
         doctorId: userid,
        message: message,
      };

      console.log("Message Body", body);

      const response = await axios.post(
        "/api/ccmessage/message-cc",
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Message Response", response.data);

      alert("Message sent successfully");

      setMessage("");

      handleClose();
    } catch (error) {
      console.log(error);

      alert("Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
        },
      }}
    >
      {/* ================= HEADER ================= */}

      <Box
        sx={{
          background:
            "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
          px: 3,
          py: 2.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Avatar
            sx={{
              width: 45,
              height: 45,
              backgroundColor: "#fff",
              color: "#5E35B1",
              fontWeight: 700,
            }}
          >
            CC
          </Avatar>

          <Box>
            <Typography
              sx={{
                color: "#fff",
                fontWeight: 700,
                fontSize: "20px",
              }}
            >
              Message Care Coordinator
            </Typography>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.8)",
                fontSize: "13px",
              }}
            >
              Send quick message to coordinator
            </Typography>
          </Box>
        </Box>

        <IconButton
          onClick={handleClose}
          sx={{
            color: "#fff",
          }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Box>

      {/* ================= CONTENT ================= */}

      <DialogContent
        sx={{
          p: 3,
          backgroundColor: "#fafafa",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#333",
            mb: 1.5,
          }}
        >
          Enter Message
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message here..."
          variant="outlined"
          sx={{
            backgroundColor: "#fff",

            "& .MuiOutlinedInput-root": {
              borderRadius: "18px",
              fontSize: "15px",
              alignItems: "flex-start",

              "& fieldset": {
                borderColor: "#d1d5db",
              },

              "&:hover fieldset": {
                borderColor: "#5E35B1",
              },

              "&.Mui-focused fieldset": {
                borderColor: "#5E35B1",
                borderWidth: "2px",
              },
            },
          }}
        />
      </DialogContent>

      {/* ================= ACTIONS ================= */}

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          backgroundColor: "#fafafa",
        }}
      >
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            borderRadius: "12px",
            textTransform: "none",
            px: 3,
            py: 1,
            borderColor: "#5E35B1",
            color: "#5E35B1",
            fontWeight: 600,

            "&:hover": {
              borderColor: "#4527A0",
              backgroundColor: "#f3f0ff",
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSendMessage}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress
                size={18}
                sx={{
                  color: "#fff",
                }}
              />
            ) : (
              <SendRoundedIcon />
            )
          }
          variant="contained"
          sx={{
            borderRadius: "12px",
            textTransform: "none",
            px: 3,
            py: 1,
            background:
              "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
            fontWeight: 600,
            boxShadow: "none",

            "&:hover": {
              background:
                "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Sending..." : "Send Message"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MessageCareCoordinatorPopup;